//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Vue from 'vue'
import Viewer from 'v-viewer' // docs: https://github.com/fengyuanchen/viewerjs
import 'viewerjs/dist/viewer.css'
import { downloadFile } from '../helpers.js'
import { mapGetters } from 'vuex'

Vue.use(Viewer)

const SHOW_INFO_PROPERTY = 'imageViewerShowInfo'
let viewerCounter = 0

export default {
  props: {
    original: {
      type: Boolean,
      default: false
    },
    showPhotoNumber: {
      type: Boolean,
      default: false
    },
    selectEnabled: {
      type: Boolean,
      default: false
    },
    selectedImages: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      firstViewed: false,
      infoShown: true,
      options: {
        rotatable: true,
        scalable: false,
        toolbar: {
          zoomIn: 1,
          zoomOut: 1,
          oneToOne: 1,
          reset: 1,
          prev: 0,
          play: 1,
          next: 0,
          rotateLeft: 0,
          rotateRight: 0,
          flipHorizontal: 0,
          flipVertical: 0
        },
        url: 'data-source',
        title: [true, (imgElement) => this.getCurrentTitle(imgElement)],
        view: (event) => this.beforeViewed(event),
        viewed: () => this.afterViewed(),
        hidden: () => this.afterHidden(),
        className: 'd-viewer-' + (++viewerCounter)
      },
      index: 0,
      images: [],

      shown: false
    }
  },
  computed: {
    ...mapGetters({
      imageViewerOptions: 'getImageViewerOptions'
    }),
    currentViewedPhotoSelected: {
      get: function () {
        return this.selectedImages.includes(this.images[this.index])
      },
      set: function (value) {
        this.$emit('selected', this.images[this.index])
      }
    }
  },
  watch: {
    imageViewerOptions: {
      handler: function (value) {
        this.updateViewerOptions()
      }
    },
    images: function (img) {
      this.options.toolbar.prev = (img && img.length > 1)
      this.options.toolbar.next = (img && img.length > 1)
    }
  },
  updated: function () {
    this.updateViewerOptions()
  },
  mounted: function () {
    let infoShown = localStorage.getItem(SHOW_INFO_PROPERTY)
    infoShown = infoShown === 'true' ? true : infoShown === 'false' ? false : null
    if (infoShown == null) {
      infoShown = this.$store.getters.getUser.view !== 'mobile'
    }
    this.infoShown = infoShown
  },
  methods: {
    inited (viewer) {
      this.$viewer = viewer
      this.$viewer.view(this.index)
      this.$viewer.reset = () => {
        this.$viewer.rotate(90)
        this.$emit('rotate90', this.getCurrentImage())
      }
    },
    view (index) {
      this.index = index
      this.$viewer.view(this.index)
    },
    show (images, index = 0) {
      if (this.images === images) {
        this.view(index)
        return
      }
      this.images = images // .slice()
      this.index = index
    },
    getCurrentImage () {
      if (this.images && this.index != null && this.index >= 0 && this.index < this.images.length) {
        return this.images[this.index]
      }
      return null
    },
    getCurrentImageElement () {
      const viewerContainer = this.getViewerContainer()
      const viewerCanvas = viewerContainer.querySelector('div.viewer-canvas')
      return viewerCanvas.querySelector('img')
    },
    getViewerContainer () {
      return document.querySelector('div.viewer-container.' + this.options.className.split(' ')[0])
    },
    beforeViewed (event) {
      this.index = event.detail.index
    },
    afterViewed () {
      const toolbarAddItems = []
      document.querySelectorAll('.viewer-toolbar >ul>li').forEach(item => {
        if (['info', 'download'].includes(item.dataset.viewerAction)) {
          toolbarAddItems.push(item.dataset.viewerAction)
        }
      })
      if (!toolbarAddItems.length) {
        this.firstViewed = true
        this.addBtn('mdi-information-outline', () => this.toggleInfo(), 'info')
        this.addBtn('mdi-download', () => this.downloadImage(), 'download')
      }
      this.updateImageSize()
      if (this.imageViewerOptions.resizeImageToViewport) {
        window.dispatchEvent(new Event('resize'))
        this.$viewer.move(-this.calculateMove(), 0)
        if (this.calculateZoom() < 1) {
          this.$viewer.zoom(-this.calculateZoom())
        }
      }
      this.shown = true
      Vue.nextTick(() => {
        if (this.$refs.selectCheckbox) {
          this.getViewerContainer().appendChild(this.$refs.selectCheckbox.$el)
        }
      })
    },
    calculateMove: function () {
      const viewFieldWidth = document.querySelector('.' + this.imageViewerOptions.className).offsetWidth
      return (window.innerWidth - viewFieldWidth) / 2
    },
    calculateZoom: function () {
      const imageWidth = document.querySelector('.viewer-canvas').childNodes[0].width
      const viewFieldWidth = document.querySelector('.' + this.imageViewerOptions.className).offsetWidth
      return (viewFieldWidth) / imageWidth
    },
    afterHidden () {
      this.images = []
      this.shown = false
    },
    addBtn (btnClass, handler, action) {
      const viewerToolbar = this.getViewerContainer().querySelector('div.viewer-toolbar')
      const ul = viewerToolbar.childNodes[0]

      let btn = document.createElement('li')
      btn.innerHTML = `<i aria-hidden="true" role="img" class="mdi q-icon ${btnClass}"></i>`
      btn.role = 'button'
      btn.class = 'viewer-' + action
      btn.setAttribute('data-viewer-action', action)
      btn.onclick = handler
      btn.setAttribute('style', 'width: 20px; height: 20px; margin: 2px 4px; font-size: 20px; color: white;')
      btn = ul.appendChild(btn)
    },
    updateViewerOptions: function () {
      if (Object.keys(this.imageViewerOptions).length > 0) {
        this.options.className += ' ' + this.imageViewerOptions.className
        this.options.container = this.imageViewerOptions.container
      } else {
        this.options.className = this.options.className.split(' ')[0]
        this.options.container = null
      }
    },
    updateImageSize () {
      if (!this.infoShown) {
        return
      }

      const viewerContainer = this.getViewerContainer()
      const viewerCanvas = viewerContainer.querySelector('div.viewer-canvas')
      const viewerFooter = viewerContainer.querySelector('div.viewer-footer')

      const imageEl = viewerCanvas.childNodes[0]
      if (imageEl) {
        const maxHeight = viewerCanvas.offsetHeight - viewerFooter.offsetHeight
        if (maxHeight < imageEl.height) {
          const zoom = -(imageEl.height - maxHeight) / maxHeight
          console.log('Height: max=' + maxHeight + ', current=' + imageEl.height + ' => zoom=' + zoom + ', x=' + imageEl.offsetLeft + ', y=0')
          this.$viewer.zoom(zoom)
          this.$viewer.moveTo(imageEl.offsetLeft, 0)
        } else if (maxHeight < imageEl.height + imageEl.offsetTop) {
          console.log('Height: max=' + maxHeight + ', current=' + imageEl.height + ' => x=' + imageEl.offsetLeft + ', y=' + (maxHeight - imageEl.height))
          this.$viewer.move(0, maxHeight - imageEl.height - imageEl.offsetTop)
        }
      }
    },
    toggleInfo () {
      this.infoShown = !this.infoShown
      localStorage.setItem(SHOW_INFO_PROPERTY, this.infoShown)

      const viewerTitle = this.getViewerContainer().querySelector('div.viewer-title')
      if (viewerTitle) {
        viewerTitle.innerHTML = this.getCurrentTitle()
      }

      this.updateImageSize()
    },
    getCurrentTitle () {
      const image = this.getCurrentImage()
      return this.getTitle(image, this.infoShown)
    },
    getTitle (image, withInfo) {
      if (!image) {
        return ''
      }
      let fullTitle = ''
      if (withInfo && image.description && image.description.length) {
        let title = ''
        for (let i = 0; i < image.description.length; i++) {
          if (image.description[i].name && image.description[i].value) {
            title += image.description[i].name + ': ' + image.description[i].value + '\n'
          }
        }
        title += '\n'
        if (image.name) {
          title += image.name + '\t'
        }
        fullTitle = title
      } else if (withInfo && !image.description) {
        fullTitle = (image.name || '') + ' (нет дополнительной информации)'
      } else {
        fullTitle = image.name || ''
      }
      const number = '(ФОТО №' + (this.index + 1) + ')'
      return fullTitle + (this.showPhotoNumber ? ' ' + number : '')
    },
    downloadImage () {
      const image = this.getCurrentImage()
      if (image) {
        const viewerCanvas = this.getViewerContainer().querySelector('div.viewer-canvas')
        const imageEl = viewerCanvas.childNodes[0]
        if (imageEl && imageEl.src) {
          downloadFile(imageEl.src + (this.original ? '&original=true' : ''))
        }
      }
    }
  }
}
